/**
 * @description
 *
 * @sort 'id'
 * @sort 'description'
 * @sort 'supervisor_g_user_id'
 * @sort 'creation_date'
 * @sort 'dispatched_date'
 * @sort 'partial_reception_date'
 * @sort 'reception_date'
 * @sort 'updated_at'
 * @sort 'created_at'
 */
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
        width: '1%',
    },
    {
        text: 'responsable',
        value: 'supervisor_g_user_full_name',
        sortable: 'supervisor_g_user_id',
    },
    {
        text: 'descripción',
        value: 'description_truncate',
        sortable: 'description',
        width: '15%',
    },
    {
        text: 'zona',
        value: 'zone',
    },
    {
        text: 'despacho',
        value: 'dispatch_date',
        sortable: true,
        align: 'right',
        format: 'date',
        width: '10%',
    },
    {
        text: 'items',
        value: 'item_number',
        align: 'center',
        width: '1%',
    },
    {
        text: 'estado',
        value: 'g_state_name',
        align: 'center',
        //sortable: 'g_state_id',
        component: {
            type: 'chip-label',
            props: {
                palette: {
                    por_despachar: 'accent lighten-3',
                    despachada: 'secondary lighten-3',
                    recepcionada_parcialmente: 'info lighten-3',
                    recepcionada: 'success lighten-3',
                    no_recepcionada: 'error lighten-3',
                },
                noEvents: true,
                small: true,
            },
        },
        width: '10%',
    },
    {
        text: 'total',
        value: 'wh_detail_dispatch_requests_total',
        format: 'currency',
    },
    {
        text: 'creación',
        value: 'created_at',
        sortable: true,
        align: 'right',
        format: 'datetime',
        width: '10%',
    },
    /*{
        text: 'modificación',
        value: 'updated_at',
        sortable: true,
        align: 'right',
        format: 'datetime',
        width: '10%',
    },*/
]
